import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './style.css';

class MyPlate extends Component {
  render() {
    const {
      hasDairy,
      hasVegetable,
      hasFruit,
      hasProtein,
      hasGrain,
    } = this.props.selectedComponents;

    const size = this.props.isSmallSize ? '210 210 180 160' : '0 0 612 792';

    return (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox={size}
      >
        <g id="plate_shadow">
          <radialGradient
            id="SVGID_1_"
            cx="277.2435"
            cy="601.3567"
            r="33.7404"
            gradientTransform="matrix(1.6612 0 0 1.6783 -162.3154 -730.755)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.8466" style={{ stopColor: '#737373' }} />
            <stop offset="0.9264" style={{ stopColor: '#B3B3B3' }} />
            <stop offset="1" style={{ stopColor: '#FFFFFF' }} />
          </radialGradient>
          <path
            className="st1"
            d="M354.29,278.5c0,31.27-25.1,56.62-56.05,56.62c-30.96,0-56.06-25.35-56.06-56.62
          c0-31.27,25.1-56.62,56.06-56.62C329.2,221.88,354.29,247.23,354.29,278.5z"
          />
        </g>
        <g id="plate_x2F_fork">
          <path
            className="st2"
            d="M239.45,264.92c0,0,3.01-2.94,3.06-6.22c0.04-3.19-1.55-19.56-1.55-19.56c0-0.24-0.16-0.44-0.36-0.44
          c-0.2,0-0.36,0.2-0.36,0.44c0,0.01-0.2,16.56-0.2,16.56c0,0.27-0.19,0.48-0.43,0.48c0,0,0,0-0.01,0h-0.29c0,0,0,0-0.01,0
          c-0.24,0-0.43-0.22-0.43-0.48l-0.2-16.6c-0.01-0.23-0.19-0.41-0.41-0.41c-0.22,0-0.4,0.18-0.41,0.41h0l-0.2,16.6
          c0,0.27-0.19,0.48-0.43,0.48c0,0,0,0-0.01,0h-0.29c0,0,0,0-0.01,0c-0.24,0-0.43-0.22-0.43-0.48l-0.2-16.6
          c-0.01-0.23-0.19-0.41-0.41-0.41c-0.22,0-0.4,0.18-0.41,0.41h0l0,0.02c0,0,0,0,0,0.01c0,0,0,0,0,0.01l-0.2,16.57
          c0,0.27-0.19,0.48-0.43,0.48c0,0,0,0-0.01,0h-0.29c0,0,0,0-0.01,0c-0.23,0-0.43-0.22-0.43-0.48l-0.2-16.6
          c-0.01-0.23-0.17-0.41-0.36-0.41c-0.19,0-0.35,0.18-0.36,0.41h0c0,0-1.6,16.32-1.56,19.6c0.05,3.28,3.06,6.22,3.06,6.22
          c1.25,1.09,0.86,4.51,0.86,7c0,2.54-1.66,35.18-1.62,35.73c0.15,3.24,1.49,4.31,3.13,4.45v0c0,0,0.01,0,0.01,0c0,0,0.01,0,0.01,0v0
          c1.64-0.13,2.98-1.21,3.13-4.45c0.04-0.55-1.63-33.19-1.63-35.73C238.59,269.43,238.2,266.01,239.45,264.92z"
          />
          <linearGradient
            id="SVGID_2_"
            gradientUnits="userSpaceOnUse"
            x1="300.897"
            y1="221.9091"
            x2="300.897"
            y2="329.9106"
          >
            <stop offset="0.0178" style={{ stopColor: '#F2F2F2' }} />
            <stop offset="1" style={{ stopColor: '#CCCCCC' }} />
          </linearGradient>
          <circle className="st3" cx="300.9" cy="275.65" r="54.52" />
          <linearGradient
            id="SVGID_3_"
            gradientUnits="userSpaceOnUse"
            x1="300.897"
            y1="223.6832"
            x2="300.897"
            y2="328.1197"
          >
            <stop offset="0" style={{ stopColor: '#BFBFBF' }} />
            <stop offset="0.9553" style={{ stopColor: '#FFFFFF' }} />
          </linearGradient>
          <circle className="st4" cx="300.9" cy="275.65" r="52.73" />
        </g>
        <g id="dairy_shadow">
          <radialGradient
            id="SVGID_4_"
            cx="316.2561"
            cy="583.6921"
            r="12.2424"
            gradientTransform="matrix(1.6612 0 0 1.6783 -162.3154 -730.755)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.8466" style={{ stopColor: '#737373' }} />
            <stop offset="0.9264" style={{ stopColor: '#B3B3B3' }} />
            <stop offset="1" style={{ stopColor: '#FFFFFF' }} />
          </radialGradient>
          <path
            className="st5"
            d="M383.39,248.86c0,11.35-9.11,20.54-20.34,20.54c-11.23,0-20.34-9.2-20.34-20.54
          c0-11.35,9.11-20.55,20.34-20.55C374.28,228.31,383.39,237.51,383.39,248.86z"
          />
        </g>
        <g id="dairy">
          <g>
            <linearGradient
              id="SVGID_5_"
              gradientUnits="userSpaceOnUse"
              x1="364.0435"
              y1="225.2943"
              x2="364.0435"
              y2="266.3025"
            >
              <stop offset="0" style={{ stopColor: '#FFFFFF' }} />
              <stop offset="1" style={{ stopColor: '#D9D9D9' }} />
            </linearGradient>
            <path
              className="st6"
              d="M384.85,245.68c0,11.49-9.31,20.81-20.81,20.81c-11.49,0-20.81-9.32-20.81-20.81
            c0-11.49,9.32-20.81,20.81-20.81C375.54,224.88,384.85,234.19,384.85,245.68z"
            />
            <linearGradient
              id="SVGID_6_"
              gradientUnits="userSpaceOnUse"
              x1="364.0434"
              y1="263.717"
              x2="364.0434"
              y2="227.8899"
            >
              <stop offset="0" style={{ stopColor: '#FFFFFF' }} />
              <stop offset="1" style={{ stopColor: '#BFBFBF' }} />
            </linearGradient>
            <path
              className="st7"
              d="M382.83,245.68c0,10.38-8.41,18.78-18.79,18.78c-10.38,0-18.78-8.41-18.78-18.78
            c0-10.37,8.41-18.78,18.78-18.78C374.42,226.9,382.83,235.31,382.83,245.68z"
            />
            <g>
              <path
                className={hasDairy ? 'st8' : 'st8g'}
                d="M380.99,245.68c0,9.36-7.59,16.95-16.95,16.95c-9.36,0-16.95-7.59-16.95-16.95
              c0-9.36,7.59-16.95,16.95-16.95C373.4,228.73,380.99,236.32,380.99,245.68z"
              />
              <path
                className={hasDairy ? 'st9' : 'st9g'}
                d="M379.53,245.68c0,8.55-6.93,15.48-15.48,15.48c-8.55,0-15.48-6.93-15.48-15.48
              c0-8.55,6.93-15.48,15.48-15.48C372.6,230.2,379.53,237.13,379.53,245.68z"
              />
              <linearGradient
                id="SVGID_7_"
                gradientUnits="userSpaceOnUse"
                x1="351.5071"
                y1="261.776"
                x2="369.7646"
                y2="238.3372"
              >
                <stop offset="0" style={{ stopColor: '#80B1D3' }} />
                <stop offset="1" style={{ stopColor: '#456FB1' }} />
              </linearGradient>
              <linearGradient
                id="SVGID_7_g"
                gradientUnits="userSpaceOnUse"
                x1="351.508"
                y1="261.7761"
                x2="369.7655"
                y2="238.3373"
              >
                <stop offset="0" style={{ stopColor: '#BFBFBF' }} />
                <stop offset="1" style={{ stopColor: '#8C8C8C' }} />
              </linearGradient>
              <path
                className={hasDairy ? 'st10' : 'st10g'}
                d="M377.63,245.68c0,7.5-6.08,13.59-13.59,13.59c-7.51,0-13.59-6.09-13.59-13.59
              c0-7.51,6.08-13.59,13.59-13.59C371.55,232.09,377.63,238.18,377.63,245.68z"
              />
            </g>
          </g>
        </g>
        <g id="wedges_1_">
          <g id="wedges_level_1">
            <g>
              <path
                className={hasVegetable ? 'st11' : 'st11g'}
                d="M255.17,272.29c-0.04,0.6-0.07,1.2-0.09,1.8c-0.02,0.52-0.03,1.04-0.03,1.57c0,0.08,0,0.16,0,0.23
              c0.12,23.86,18.45,43.41,41.8,45.48c0.6,0.05,1.2,0.1,1.8,0.13c0.6,0.03,1.2,0.05,1.8,0.06v-49.26H255.17z"
              />
              <path
                className={hasFruit ? 'st12' : 'st12g'}
                d="M298.64,229.82c-0.6,0.03-1.2,0.07-1.8,0.13c-20.36,1.8-36.89,16.89-40.88,36.54
              c-0.12,0.6-0.23,1.2-0.33,1.8c-0.1,0.6-0.18,1.2-0.26,1.8h45.06v-40.32C299.84,229.77,299.24,229.79,298.64,229.82z"
              />
              <path
                className={hasProtein ? 'st13' : 'st13g'}
                d="M302.64,280.76v37.09v2.3v1.38c0.6-0.02,1.2-0.06,1.8-0.1c0.6-0.05,1.2-0.1,1.8-0.17
              c19.97-2.3,36.03-17.4,39.77-36.89c0.11-0.6,0.22-1.2,0.31-1.8c0.09-0.6,0.17-1.2,0.24-1.8H302.64z"
              />
              <path
                className={hasGrain ? 'st14' : 'st14g'}
                d="M346.83,274.96c-0.35-23.24-17.97-42.29-40.59-44.89c-0.6-0.07-1.2-0.13-1.8-0.17
              c-0.6-0.04-1.2-0.08-1.8-0.1v48.77h44.11c0.04-0.6,0.06-1.2,0.08-1.8c0.01-0.37,0.02-0.73,0.02-1.1
              C346.84,275.43,346.84,275.19,346.83,274.96z"
              />
            </g>
          </g>
          <g id="wedges_level_2">
            <g>
              <path
                className={hasVegetable ? 'st15' : 'st15g'}
                d="M256.45,274.09c-0.02,0.52-0.03,1.04-0.03,1.57c0,0.08,0,0.16,0,0.23c0.12,23.1,17.83,42.03,40.42,44.09
              c0.6,0.05,1.2,0.1,1.8,0.13v-46.02H256.45z"
              />
              <path
                className={hasFruit ? 'st16' : 'st16g'}
                d="M296.84,231.33c-19.6,1.79-35.52,16.27-39.47,35.16c-0.12,0.6-0.24,1.2-0.34,1.8h41.61V231.2
              C298.04,231.23,297.44,231.28,296.84,231.33z"
              />
              <path
                className={hasProtein ? 'st17' : 'st17g'}
                d="M304.44,282.56v37.48c0.6-0.05,1.2-0.11,1.8-0.18c19.2-2.28,34.66-16.78,38.37-35.5
              c0.12-0.6,0.23-1.2,0.32-1.8H304.44z"
              />
              <path
                className={hasGrain ? 'st18' : 'st18g'}
                d="M345.46,274.96c-0.35-22.48-17.35-40.91-39.21-43.5c-0.6-0.07-1.2-0.13-1.8-0.18v45.48h41
              c0.01-0.37,0.02-0.73,0.02-1.1C345.46,275.43,345.46,275.19,345.46,274.96z"
              />
            </g>
          </g>
          <g id="wedges_level_3">
            <g>
              <linearGradient
                id="SVGID_8_g"
                gradientUnits="userSpaceOnUse"
                x1="296.79"
                y1="276.1537"
                x2="272.5398"
                y2="306.654"
              >
                <stop offset="0.3248" style={{ stopColor: '#B3B3B3' }} />
                <stop offset="0.4909" style={{ stopColor: '#A5A5A5' }} />
                <stop offset="1" style={{ stopColor: '#808080' }} />
              </linearGradient>
              <linearGradient
                id="SVGID_8_"
                gradientUnits="userSpaceOnUse"
                x1="296.79"
                y1="276.1537"
                x2="270.5398"
                y2="304.654"
              >
                <stop offset="0.3248" style={{ stopColor: '#B3DB11' }} />
                <stop offset="0.3557" style={{ stopColor: '#ACD812' }} />
                <stop offset="0.8002" style={{ stopColor: '#4CA525' }} />
                <stop offset="1" style={{ stopColor: '#27922D' }} />
              </linearGradient>
              <path
                className={hasVegetable ? 'st19' : 'st19g'}
                d="M296.85,317.69V275.9h-38.13C258.84,297.73,275.52,315.63,296.85,317.69z"
              />
              <linearGradient
                id="SVGID_9_"
                gradientUnits="userSpaceOnUse"
                x1="296.8046"
                y1="266.6322"
                x2="272.6546"
                y2="245.0322"
              >
                <stop offset="0" style={{ stopColor: '#F75C92' }} />
                <stop offset="0.3441" style={{ stopColor: '#F43043' }} />
                <stop offset="0.7117" style={{ stopColor: '#F20000' }} />
                <stop offset="0.9945" style={{ stopColor: '#DA0000' }} />
              </linearGradient>
              <linearGradient
                id="SVGID_9_g"
                gradientUnits="userSpaceOnUse"
                x1="296.8051"
                y1="266.6322"
                x2="272.6551"
                y2="245.0322"
              >
                <stop offset="0" style={{ stopColor: '#999999' }} />
                <stop offset="0.7117" style={{ stopColor: '#494949' }} />
                <stop offset="0.9945" style={{ stopColor: '#333333' }} />
              </linearGradient>
              <path
                className={hasFruit ? 'st20' : 'st20g'}
                d="M259.72,266.49h37.13v-32.86C278.52,235.4,263.62,248.88,259.72,266.49z"
              />
              <linearGradient
                id="SVGID_10_"
                gradientUnits="userSpaceOnUse"
                x1="306.7488"
                y1="284.2313"
                x2="329.1489"
                y2="305.6313"
              >
                <stop offset="0" style={{ stopColor: '#996EB3' }} />
                <stop offset="1" style={{ stopColor: '#431F72' }} />
              </linearGradient>
              <linearGradient
                id="SVGID_10_g"
                gradientUnits="userSpaceOnUse"
                x1="306.7494"
                y1="284.2311"
                x2="329.1496"
                y2="305.6312"
              >
                <stop offset="0" style={{ stopColor: '#959595' }} />
                <stop offset="0.175" style={{ stopColor: '#7F7F7F' }} />
                <stop offset="1" style={{ stopColor: '#1A1A1A' }} />
              </linearGradient>
              <path
                className={hasProtein ? 'st21' : 'st21g'}
                d="M342.27,284.36h-36.03v33.19C324.18,315.31,338.62,301.82,342.27,284.36z"
              />
              <linearGradient
                id="SVGID_11_"
                gradientUnits="userSpaceOnUse"
                x1="307.1053"
                y1="275.7807"
                x2="331.1053"
                y2="246.5808"
              >
                <stop offset="0" style={{ stopColor: '#E49F69' }} />
                <stop offset="0.2993" style={{ stopColor: '#DF7C37' }} />
                <stop offset="0.7546" style={{ stopColor: '#D94C00' }} />
              </linearGradient>
              <linearGradient
                id="SVGID_11_g"
                gradientUnits="userSpaceOnUse"
                x1="307.1057"
                y1="275.7805"
                x2="331.1055"
                y2="246.5808"
              >
                <stop offset="0" style={{ stopColor: '#B5B5B5' }} />
                <stop offset="0.1262" style={{ stopColor: '#A5A5A5' }} />
                <stop offset="0.7546" style={{ stopColor: '#595959' }} />
              </linearGradient>
              <path
                className={hasGrain ? 'st22' : 'st22g'}
                d="M306.25,233.77v41.19h36.92C342.82,253.75,326.84,236.35,306.25,233.77z"
              />
            </g>
          </g>
        </g>
        <g id="type__x28_outlined_x29_">
          <g>
            <path
              className="st23"
              d="M232.46,344.59v-0.03c0-3.05,2.28-5.57,5.45-5.57c1.96,0,3.12,0.69,4.2,1.71l-0.83,0.89
            c-0.91-0.86-1.92-1.48-3.39-1.48c-2.39,0-4.17,1.94-4.17,4.42v0.03c0,2.49,1.8,4.45,4.17,4.45c1.48,0,2.45-0.57,3.48-1.55
            l0.8,0.79c-1.12,1.14-2.35,1.89-4.31,1.89C234.75,350.13,232.46,347.68,232.46,344.59z"
            />
            <path
              className="st23"
              d="M243.32,338.71h1.19v4.66c0.52-0.86,1.35-1.55,2.72-1.55c1.92,0,3.05,1.29,3.05,3.19v4.94h-1.18v-4.65
            c0-1.48-0.8-2.4-2.2-2.4c-1.37,0-2.39,1-2.39,2.49v4.55h-1.19V338.71z"
            />
            <path
              className="st23"
              d="M251.16,346v-0.03c0-2.25,1.75-4.16,4.16-4.16c2.38,0,4.14,1.88,4.14,4.12v0.03c0,2.25-1.77,4.15-4.17,4.15
            C252.9,350.13,251.16,348.25,251.16,346z M258.24,346v-0.03c0-1.71-1.28-3.11-2.96-3.11c-1.72,0-2.91,1.4-2.91,3.08v0.03
            c0,1.71,1.26,3.09,2.94,3.09C257.04,349.07,258.24,347.68,258.24,346z"
            />
            <path
              className="st23"
              d="M259.94,346v-0.03c0-2.25,1.75-4.16,4.15-4.16c2.39,0,4.14,1.88,4.14,4.12v0.03c0,2.25-1.77,4.15-4.17,4.15
            C261.68,350.13,259.94,348.25,259.94,346z M267.02,346v-0.03c0-1.71-1.28-3.11-2.96-3.11c-1.72,0-2.91,1.4-2.91,3.08v0.03
            c0,1.71,1.26,3.09,2.94,3.09C265.82,349.07,267.02,347.68,267.02,346z"
            />
            <path
              className="st23"
              d="M268.56,348.93l0.6-0.85c0.86,0.65,1.82,1.02,2.75,1.02c0.95,0,1.65-0.49,1.65-1.26v-0.03
            c0-0.8-0.94-1.11-1.98-1.4c-1.25-0.35-2.63-0.79-2.63-2.25v-0.03c0-1.37,1.14-2.28,2.71-2.28c0.97,0,2.05,0.34,2.86,0.88
            l-0.54,0.89c-0.74-0.48-1.58-0.77-2.35-0.77c-0.94,0-1.54,0.49-1.54,1.15v0.03c0,0.75,0.98,1.05,2.05,1.37
            c1.23,0.37,2.55,0.85,2.55,2.28v0.03c0,1.51-1.25,2.39-2.83,2.39C270.72,350.1,269.45,349.65,268.56,348.93z"
            />
            <path
              className="st23"
              d="M279.24,349.1c1.09,0,1.86-0.45,2.51-1.12l0.74,0.66c-0.8,0.89-1.77,1.49-3.28,1.49
            c-2.19,0-3.97-1.68-3.97-4.15c0-2.31,1.62-4.16,3.82-4.16c2.35,0,3.71,1.88,3.71,4.22c0,0.11,0,0.23-0.02,0.42h-6.31
            C276.61,348.13,277.84,349.1,279.24,349.1z M281.57,345.5c-0.14-1.45-0.97-2.68-2.54-2.68c-1.37,0-2.42,1.14-2.58,2.68H281.57z"
            />
            <path d="M283.83,339.17h3.75l2.31,3.79l2.31-3.79h3.75v10.77h-3.59v-5.34l-2.48,3.83h-0.06l-2.48-3.83v5.34h-3.52V339.17z" />
            <path
              d="M296.78,351.58l1.02-2.39c0.63,0.35,1.22,0.55,1.54,0.55c0.2,0,0.38-0.03,0.57-0.12l-3.29-8.08h3.62l1.46,4.43l1.34-4.43
            h3.56l-2.91,7.82c-0.82,2.2-1.71,3.09-3.65,3.09C298.82,352.45,297.72,352.1,296.78,351.58z"
            />
            <path
              d="M307.22,339.17h4.85c2.86,0,4.82,1.28,4.82,3.83v0.03c0,2.6-1.99,3.99-4.89,3.99h-1.17v2.92h-3.6V339.17z M311.79,344.45
            c0.92,0,1.54-0.42,1.54-1.18v-0.03c0-0.78-0.57-1.18-1.52-1.18h-0.99v2.4H311.79z"
            />
            <path d="M317.59,338.71h3.49v11.23h-3.49V338.71z" />
            <path
              d="M321.84,347.56v-0.03c0-1.68,1.25-2.62,3.2-2.62c0.71,0,1.62,0.15,1.99,0.31v-0.14c0-0.77-0.48-1.22-1.55-1.22
            c-0.86,0-1.58,0.19-2.32,0.48l-0.62-2.32c0.97-0.37,2.08-0.62,3.54-0.62c1.71,0,2.82,0.35,3.56,1.09
            c0.63,0.63,0.88,1.45,0.88,2.66v4.79h-3.49v-0.85c-0.58,0.63-1.37,1.05-2.42,1.05C322.98,350.14,321.84,349.22,321.84,347.56z
             M327.05,346.84v-0.35c-0.2-0.08-0.51-0.14-0.8-0.14c-0.69,0-1.08,0.41-1.08,0.94v0.03c0,0.49,0.35,0.82,0.8,0.82
            C326.59,348.13,327.05,347.64,327.05,346.84z"
            />
            <path
              d="M332.06,347.13v-2.89h-0.99v-2.69h0.99v-2.11h3.49v2.11h1.94v2.69h-1.94v2.12c0,0.63,0.29,0.86,0.85,0.86
            c0.32,0,0.69-0.09,1.06-0.26v2.69c-0.55,0.29-1.39,0.48-2.23,0.48C333.17,350.13,332.06,349.18,332.06,347.13z"
            />
            <path
              d="M337.78,345.79v-0.03c0-2.51,1.8-4.42,4.32-4.42c2.99,0,4.37,2.08,4.37,4.63c0,0.18,0,0.4-0.02,0.58h-5.4
            c0.25,0.74,0.83,1.12,1.59,1.12c0.63,0,1.15-0.29,1.71-0.86l1.88,1.49c-0.83,1.08-2.02,1.83-3.83,1.83
            C339.64,350.14,337.78,348.41,337.78,345.79z M343.29,345.02c-0.08-0.8-0.55-1.26-1.17-1.26c-0.58,0-1,0.49-1.11,1.26H343.29z"
            />
            <path className="st23" d="M347.91,348.33h1.42v1.62h-1.42V348.33z" />
            <path
              className="st23"
              d="M350.42,351.33l0.54-0.92c0.91,0.66,1.92,1.02,3.06,1.02c1.75,0,2.89-0.97,2.89-2.83v-0.94
            c-0.69,0.92-1.66,1.68-3.12,1.68c-1.91,0-3.74-1.43-3.74-3.72v-0.03c0-2.32,1.85-3.76,3.74-3.76c1.49,0,2.46,0.74,3.11,1.6v-1.43
            h1.18v6.57c0,1.23-0.37,2.17-1.02,2.82c-0.71,0.71-1.77,1.06-3.03,1.06C352.71,352.44,351.48,352.07,350.42,351.33z
             M356.94,345.59v-0.03c0-1.63-1.42-2.69-2.92-2.69c-1.51,0-2.75,1.05-2.75,2.68v0.03c0,1.6,1.28,2.71,2.75,2.71
            C355.53,348.28,356.94,347.19,356.94,345.59z"
            />
            <path
              className="st23"
              d="M359.08,346v-0.03c0-2.25,1.75-4.16,4.16-4.16c2.39,0,4.14,1.88,4.14,4.12v0.03c0,2.25-1.77,4.15-4.17,4.15
            C360.82,350.13,359.08,348.25,359.08,346z M366.16,346v-0.03c0-1.71-1.28-3.11-2.96-3.11c-1.72,0-2.91,1.4-2.91,3.08v0.03
            c0,1.71,1.26,3.09,2.94,3.09C364.96,349.07,366.16,347.68,366.16,346z"
            />
            <path
              className="st23"
              d="M367.11,341.99h1.31l2.68,6.6l2.69-6.6h1.28l-3.46,8.02h-1.05L367.11,341.99z"
            />
          </g>
          <g>
            <g>
              <path
                className="st0"
                d="M313.3,257.14c1.3,0,1.94,0.67,1.94,0.67l-0.55,0.71c0,0-0.55-0.47-1.36-0.47c-0.92,0-1.71,0.73-1.71,1.81
              c0,1.16,0.79,1.87,1.75,1.87c0.85,0,1.35-0.55,1.35-0.55v-0.4c0-0.11-0.06-0.17-0.17-0.17h-0.32v-0.83h0.86
              c0.36,0,0.51,0.15,0.51,0.5v2.27h-0.84v-0.25c0-0.11,0.01-0.23,0.01-0.23h-0.02c0,0-0.57,0.57-1.57,0.57
              c-1.39,0-2.59-1.07-2.59-2.78C310.6,258.34,311.76,257.14,313.3,257.14z"
              />
              <path
                className="st0"
                d="M316.62,259.71c0-0.11-0.06-0.17-0.17-0.17h-0.3v-0.81h0.87c0.34,0,0.51,0.14,0.51,0.46v0.22
              c0,0.14-0.01,0.24-0.01,0.24h0.01c0.17-0.55,0.63-0.98,1.21-0.98c0.08,0,0.17,0.02,0.17,0.02v0.94c0,0-0.1-0.01-0.23-0.01
              c-0.4,0-0.87,0.23-1.04,0.8c-0.05,0.19-0.08,0.4-0.08,0.62v1.51h-0.94V259.71z"
              />
              <path
                className="st0"
                d="M321.38,260.16h0.12v-0.03c0-0.55-0.22-0.75-0.7-0.75c-0.17,0-0.51,0.05-0.51,0.25v0.2h-0.88v-0.4
              c0-0.71,1-0.79,1.4-0.79c1.28,0,1.65,0.67,1.65,1.52v1.42c0,0.11,0.06,0.17,0.16,0.17h0.3v0.8h-0.86c-0.35,0-0.49-0.2-0.49-0.42
              c0-0.1,0.01-0.17,0.01-0.17h-0.01c0,0-0.29,0.67-1.16,0.67c-0.68,0-1.3-0.43-1.3-1.19C319.11,260.26,320.76,260.16,321.38,260.16
              z M320.65,261.91c0.51,0,0.87-0.54,0.87-1v-0.09h-0.17c-0.5,0-1.28,0.07-1.28,0.6C320.07,261.67,320.26,261.91,320.65,261.91z"
              />
              <path
                className="st0"
                d="M323.71,259.71c0-0.11-0.06-0.17-0.17-0.17h-0.3v-0.81h0.91c0.35,0,0.5,0.16,0.5,0.51v2.35
              c0,0.11,0.06,0.17,0.16,0.17h0.3v0.8h-0.91c-0.35,0-0.5-0.15-0.5-0.51V259.71z M323.76,257.23h0.83v0.88h-0.83V257.23z"
              />
              <path
                className="st0"
                d="M325.93,259.71c0-0.11-0.06-0.17-0.17-0.17h-0.3v-0.81h0.88c0.34,0,0.5,0.16,0.5,0.43v0.11
              c0,0.08-0.01,0.16-0.01,0.16h0.01c0.17-0.32,0.58-0.79,1.35-0.79c0.85,0,1.33,0.44,1.33,1.45v1.49c0,0.11,0.06,0.17,0.16,0.17
              h0.3v0.8h-0.91c-0.36,0-0.51-0.15-0.51-0.51v-1.75c0-0.46-0.12-0.78-0.6-0.78c-0.51,0-0.89,0.32-1.03,0.78
              c-0.05,0.16-0.07,0.33-0.07,0.51v1.75h-0.95V259.71z"
              />
              <path
                className="st0"
                d="M330.76,261.34c0,0,0.49,0.56,1.14,0.56c0.29,0,0.52-0.12,0.52-0.38c0-0.54-2.02-0.53-2.02-1.77
              c0-0.77,0.69-1.12,1.49-1.12c0.52,0,1.34,0.17,1.34,0.79v0.4h-0.84v-0.19c0-0.18-0.27-0.27-0.48-0.27
              c-0.34,0-0.57,0.12-0.57,0.34c0,0.6,2.03,0.48,2.03,1.75c0,0.72-0.64,1.17-1.47,1.17c-1.05,0-1.59-0.68-1.59-0.68L330.76,261.34z
              "
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="st0"
                d="M354.99,243.23h-0.49v-0.83h2.17c1.64,0,2.71,0.98,2.71,2.65c0,1.68-1.07,2.67-2.71,2.67h-1.17
              c-0.36,0-0.51-0.15-0.51-0.51V243.23z M356.13,246.89h0.48c1.06,0,1.75-0.64,1.75-1.84c0-1.18-0.7-1.82-1.75-1.82h-0.64v3.49
              C355.97,246.83,356.03,246.89,356.13,246.89z"
              />
              <path
                className="st0"
                d="M362.16,245.33h0.12v-0.03c0-0.55-0.22-0.75-0.71-0.75c-0.17,0-0.51,0.04-0.51,0.25v0.2h-0.88v-0.4
              c0-0.71,1-0.79,1.4-0.79c1.27,0,1.65,0.67,1.65,1.52v1.42c0,0.11,0.06,0.17,0.17,0.17h0.3v0.8h-0.85c-0.35,0-0.49-0.2-0.49-0.42
              c0-0.1,0.01-0.17,0.01-0.17h-0.01c0,0-0.29,0.67-1.16,0.67c-0.68,0-1.3-0.43-1.3-1.19C359.89,245.42,361.54,245.33,362.16,245.33
              z M361.43,247.07c0.51,0,0.87-0.54,0.87-1v-0.09h-0.17c-0.49,0-1.28,0.07-1.28,0.6C360.85,246.83,361.04,247.07,361.43,247.07z"
              />
              <path
                className="st0"
                d="M364.5,244.88c0-0.11-0.06-0.17-0.17-0.17h-0.3v-0.81h0.91c0.35,0,0.5,0.16,0.5,0.51v2.35
              c0,0.11,0.06,0.17,0.17,0.17h0.3v0.8H365c-0.35,0-0.5-0.15-0.5-0.51V244.88z M364.54,242.4h0.83v0.88h-0.83V242.4z"
              />
              <path
                className="st0"
                d="M366.71,244.88c0-0.11-0.06-0.17-0.17-0.17h-0.3v-0.81h0.87c0.34,0,0.51,0.14,0.51,0.46v0.22
              c0,0.14-0.01,0.24-0.01,0.24h0.01c0.17-0.55,0.63-0.98,1.21-0.98c0.08,0,0.17,0.02,0.17,0.02v0.94c0,0-0.1-0.01-0.23-0.01
              c-0.4,0-0.87,0.23-1.04,0.8c-0.05,0.19-0.08,0.4-0.08,0.62v1.51h-0.95V244.88z"
              />
              <path
                className="st0"
                d="M370.2,248.5c0.26,0,0.5-0.16,0.63-0.49l0.13-0.29l-1.28-2.87c-0.04-0.11-0.1-0.13-0.2-0.13h-0.11v-0.81
              h0.63c0.27,0,0.41,0.1,0.5,0.36l0.75,1.91c0.08,0.2,0.14,0.51,0.14,0.51h0.01c0,0,0.06-0.31,0.13-0.51l0.65-1.91
              c0.09-0.26,0.25-0.36,0.51-0.36h0.65v0.81h-0.11c-0.11,0-0.17,0.02-0.22,0.13l-1.37,3.46c-0.27,0.69-0.81,1-1.38,1
              c-0.6,0-0.97-0.39-0.97-0.39l0.37-0.67C369.65,248.24,369.88,248.5,370.2,248.5z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="st0"
                d="M270.96,253.28h-0.49v-0.83h3.04c0.36,0,0.51,0.16,0.51,0.51v0.81h-0.88v-0.32c0-0.11-0.06-0.17-0.16-0.17
              h-1.03v1.51h1.7v0.83h-1.7v2.15h-0.98V253.28z"
              />
              <path
                className="st0"
                d="M274.78,254.92c0-0.11-0.06-0.16-0.17-0.16h-0.3v-0.81h0.87c0.34,0,0.51,0.14,0.51,0.46v0.23
              c0,0.14-0.02,0.24-0.02,0.24h0.02c0.17-0.55,0.63-0.98,1.21-0.98c0.08,0,0.17,0.01,0.17,0.01v0.94c0,0-0.1-0.02-0.23-0.02
              c-0.4,0-0.87,0.23-1.04,0.8c-0.05,0.19-0.08,0.4-0.08,0.62v1.51h-0.94V254.92z"
              />
              <path
                className="st0"
                d="M277.9,254.92c0-0.11-0.06-0.16-0.17-0.16h-0.3v-0.81h0.91c0.35,0,0.5,0.16,0.5,0.5v1.76
              c0,0.46,0.12,0.78,0.59,0.78c0.69,0,1.07-0.61,1.07-1.29v-1.75h0.95v2.86c0,0.1,0.06,0.16,0.17,0.16h0.3v0.8h-0.88
              c-0.33,0-0.5-0.16-0.5-0.43v-0.1c0-0.09,0.01-0.17,0.01-0.17h-0.01c-0.18,0.4-0.66,0.79-1.32,0.79c-0.82,0-1.32-0.41-1.32-1.45
              V254.92z"
              />
              <path
                className="st0"
                d="M282.73,254.92c0-0.11-0.06-0.16-0.17-0.16h-0.3v-0.81h0.91c0.35,0,0.5,0.16,0.5,0.51v2.35
              c0,0.1,0.06,0.16,0.17,0.16h0.3v0.8h-0.91c-0.35,0-0.5-0.15-0.5-0.51V254.92z M282.78,252.44h0.82v0.88h-0.82V252.44z"
              />
              <path
                className="st0"
                d="M284.96,254.7h-0.49v-0.76h0.52v-1.04h0.93v1.04h0.87v0.76h-0.87v1.54c0,0.63,0.49,0.72,0.76,0.72
              c0.11,0,0.17-0.02,0.17-0.02v0.83c0,0-0.12,0.02-0.29,0.02c-0.53,0-1.59-0.16-1.59-1.44V254.7z"
              />
              <path
                className="st0"
                d="M287.74,256.55c0,0,0.49,0.56,1.14,0.56c0.29,0,0.52-0.12,0.52-0.38c0-0.54-2.02-0.53-2.02-1.77
              c0-0.76,0.69-1.12,1.48-1.12c0.52,0,1.34,0.17,1.34,0.79v0.4h-0.84v-0.19c0-0.18-0.27-0.27-0.48-0.27
              c-0.34,0-0.57,0.12-0.57,0.34c0,0.6,2.03,0.48,2.03,1.75c0,0.72-0.64,1.17-1.47,1.17c-1.05,0-1.59-0.68-1.59-0.68L287.74,256.55z
              "
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="st0"
                d="M260.8,285.03c-0.04-0.13-0.11-0.17-0.23-0.17h-0.13v-0.83h0.62c0.38,0,0.51,0.1,0.63,0.43l1.02,2.97
              c0.11,0.3,0.2,0.78,0.2,0.78h0.02c0,0,0.1-0.48,0.2-0.78l1.02-2.97c0.12-0.34,0.25-0.43,0.62-0.43h0.63v0.83h-0.14
              c-0.13,0-0.19,0.04-0.23,0.17l-1.59,4.33h-1.04L260.8,285.03z"
              />
              <path
                className="st0"
                d="M267.11,285.44c1.09,0,1.69,0.8,1.69,1.81c0,0.11-0.02,0.35-0.02,0.35h-2.64c0.08,0.67,0.57,1.03,1.15,1.03
              c0.61,0,1.07-0.43,1.07-0.43l0.4,0.66c0,0-0.58,0.58-1.54,0.58c-1.27,0-2.05-0.92-2.05-2
              C265.17,286.27,265.97,285.44,267.11,285.44z M267.83,286.95c-0.01-0.46-0.33-0.77-0.72-0.77c-0.49,0-0.83,0.29-0.94,0.77H267.83
              z"
              />
              <path
                className="st0"
                d="M270.89,285.44c0.88,0,1.18,0.54,1.18,0.54h0.02c0,0,0-0.04,0-0.1c0-0.17,0.12-0.35,0.42-0.35h0.88v0.81
              h-0.29c-0.1,0-0.16,0.05-0.16,0.15v2.63c0,1.31-1.02,1.81-2.02,1.81c-0.48,0-0.99-0.13-1.36-0.33l0.29-0.75
              c0,0,0.47,0.25,1.06,0.25c0.58,0,1.08-0.25,1.08-0.94v-0.18c0-0.09,0.01-0.2,0.01-0.2h-0.02c-0.22,0.32-0.55,0.49-1.06,0.49
              c-1.09,0-1.72-0.88-1.72-1.93S269.79,285.44,270.89,285.44z M272.01,287.36c0-0.87-0.43-1.1-0.95-1.1
              c-0.58,0-0.89,0.42-0.89,1.06c0,0.67,0.34,1.16,0.95,1.16C271.58,288.48,272.01,288.22,272.01,287.36z"
              />
              <path
                className="st0"
                d="M275.58,285.44c1.09,0,1.69,0.8,1.69,1.81c0,0.11-0.02,0.35-0.02,0.35h-2.64c0.08,0.67,0.57,1.03,1.15,1.03
              c0.62,0,1.07-0.43,1.07-0.43l0.4,0.66c0,0-0.58,0.58-1.54,0.58c-1.27,0-2.05-0.92-2.05-2
              C273.64,286.27,274.43,285.44,275.58,285.44z M276.3,286.95c-0.02-0.46-0.33-0.77-0.72-0.77c-0.49,0-0.83,0.29-0.94,0.77H276.3z"
              />
              <path
                className="st0"
                d="M278.06,286.29h-0.5v-0.76h0.52v-1.04h0.93v1.04h0.87v0.76h-0.87v1.54c0,0.63,0.5,0.72,0.76,0.72
              c0.1,0,0.17-0.02,0.17-0.02v0.83c0,0-0.12,0.02-0.29,0.02c-0.53,0-1.59-0.16-1.59-1.44V286.29z"
              />
              <path
                className="st0"
                d="M282.55,286.96h0.12v-0.03c0-0.55-0.22-0.75-0.7-0.75c-0.17,0-0.51,0.04-0.51,0.25v0.2h-0.88v-0.41
              c0-0.71,1-0.79,1.4-0.79c1.27,0,1.65,0.67,1.65,1.52v1.42c0,0.1,0.06,0.17,0.17,0.17h0.3v0.8h-0.85c-0.35,0-0.49-0.2-0.49-0.42
              c0-0.1,0.01-0.17,0.01-0.17h-0.02c0,0-0.29,0.67-1.15,0.67c-0.68,0-1.3-0.43-1.3-1.19C280.28,287.06,281.93,286.96,282.55,286.96
              z M281.81,288.71c0.51,0,0.87-0.54,0.87-1v-0.09h-0.17c-0.49,0-1.28,0.07-1.28,0.6C281.24,288.47,281.42,288.71,281.81,288.71z"
              />
              <path
                className="st0"
                d="M284.67,285.01c0-0.11-0.06-0.17-0.17-0.17h-0.3v-0.81h0.91c0.35,0,0.51,0.16,0.51,0.51v1.11
              c0,0.19-0.01,0.32-0.01,0.32h0.01c0,0,0.34-0.53,1.15-0.53c1.03,0,1.69,0.82,1.69,2c0,1.21-0.74,2-1.75,2
              c-0.79,0-1.14-0.54-1.14-0.54h-0.02c0,0,0.02,0.11,0.02,0.25v0.2h-0.9V285.01z M286.55,288.65c0.52,0,0.96-0.43,0.96-1.18
              c0-0.73-0.39-1.2-0.95-1.2c-0.49,0-0.96,0.36-0.96,1.21C285.59,288.06,285.91,288.65,286.55,288.65z"
              />
              <path
                className="st0"
                d="M289.1,285.01c0-0.11-0.06-0.17-0.17-0.17h-0.3v-0.81h0.91c0.35,0,0.51,0.16,0.51,0.51v3.85
              c0,0.1,0.06,0.17,0.17,0.17h0.29v0.8h-0.9c-0.36,0-0.51-0.15-0.51-0.51V285.01z"
              />
              <path
                className="st0"
                d="M292.72,285.44c1.09,0,1.69,0.8,1.69,1.81c0,0.11-0.02,0.35-0.02,0.35h-2.64c0.07,0.67,0.57,1.03,1.15,1.03
              c0.61,0,1.07-0.43,1.07-0.43l0.4,0.66c0,0-0.58,0.58-1.54,0.58c-1.27,0-2.05-0.92-2.05-2
              C290.78,286.27,291.57,285.44,292.72,285.44z M293.44,286.95c-0.02-0.46-0.33-0.77-0.72-0.77c-0.49,0-0.83,0.29-0.94,0.77H293.44
              z"
              />
              <path
                className="st0"
                d="M295.2,288.14c0,0,0.49,0.56,1.14,0.56c0.29,0,0.52-0.12,0.52-0.38c0-0.54-2.02-0.53-2.02-1.77
              c0-0.76,0.69-1.12,1.48-1.12c0.52,0,1.34,0.17,1.34,0.79v0.4h-0.84v-0.19c0-0.18-0.27-0.27-0.48-0.27
              c-0.34,0-0.57,0.12-0.57,0.35c0,0.6,2.03,0.48,2.03,1.75c0,0.72-0.64,1.17-1.47,1.17c-1.05,0-1.59-0.68-1.59-0.68L295.2,288.14z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="st0"
                d="M309.88,291.53h-0.49v-0.83h2.44c1,0,1.7,0.7,1.7,1.73s-0.7,1.75-1.7,1.75h-0.97v1.84h-0.98V291.53z
               M311.65,293.34c0.55,0,0.87-0.36,0.87-0.91c0-0.55-0.32-0.9-0.85-0.9h-0.8v1.81H311.65z"
              />
              <path
                className="st0"
                d="M314.3,293.17c0-0.11-0.06-0.17-0.17-0.17h-0.3v-0.81h0.87c0.34,0,0.51,0.14,0.51,0.46v0.23
              c0,0.14-0.01,0.24-0.01,0.24h0.01c0.17-0.55,0.63-0.98,1.21-0.98c0.08,0,0.17,0.01,0.17,0.01v0.94c0,0-0.1-0.01-0.23-0.01
              c-0.41,0-0.87,0.23-1.04,0.8c-0.05,0.19-0.08,0.4-0.08,0.62v1.51h-0.94V293.17z"
              />
              <path
                className="st0"
                d="M318.96,292.1c1.17,0,2.1,0.83,2.1,2c0,1.18-0.93,2-2.1,2c-1.16,0-2.09-0.82-2.09-2
              C316.87,292.94,317.8,292.1,318.96,292.1z M318.96,295.3c0.62,0,1.14-0.48,1.14-1.19c0-0.7-0.52-1.19-1.14-1.19
              c-0.61,0-1.13,0.49-1.13,1.19C317.83,294.82,318.34,295.3,318.96,295.3z"
              />
              <path
                className="st0"
                d="M321.94,292.95h-0.5v-0.76h0.52v-1.04h0.93v1.04h0.87v0.76h-0.87v1.54c0,0.63,0.5,0.72,0.76,0.72
              c0.11,0,0.17-0.02,0.17-0.02v0.83c0,0-0.12,0.02-0.29,0.02c-0.53,0-1.59-0.16-1.59-1.44V292.95z"
              />
              <path
                className="st0"
                d="M326.2,292.1c1.09,0,1.69,0.8,1.69,1.81c0,0.11-0.02,0.35-0.02,0.35h-2.64c0.08,0.68,0.57,1.03,1.15,1.03
              c0.62,0,1.07-0.43,1.07-0.43l0.4,0.66c0,0-0.58,0.58-1.54,0.58c-1.27,0-2.05-0.91-2.05-2C324.25,292.93,325.05,292.1,326.2,292.1
              z M326.92,293.61c-0.01-0.46-0.33-0.77-0.72-0.77c-0.49,0-0.83,0.29-0.94,0.77H326.92z"
              />
              <path
                className="st0"
                d="M328.84,293.17c0-0.11-0.06-0.17-0.17-0.17h-0.3v-0.81h0.91c0.35,0,0.5,0.16,0.5,0.51v2.35
              c0,0.1,0.06,0.17,0.17,0.17h0.3v0.8h-0.91c-0.35,0-0.5-0.15-0.5-0.51V293.17z M328.89,290.69h0.83v0.88h-0.83V290.69z"
              />
              <path
                className="st0"
                d="M331.06,293.17c0-0.11-0.06-0.17-0.16-0.17h-0.3v-0.81h0.88c0.34,0,0.5,0.16,0.5,0.43v0.11
              c0,0.08-0.01,0.16-0.01,0.16h0.01c0.17-0.32,0.58-0.79,1.35-0.79c0.85,0,1.33,0.44,1.33,1.45v1.49c0,0.1,0.06,0.17,0.17,0.17h0.3
              v0.8h-0.91c-0.36,0-0.51-0.15-0.51-0.51v-1.75c0-0.46-0.12-0.78-0.6-0.78c-0.51,0-0.89,0.32-1.03,0.78
              c-0.05,0.16-0.07,0.33-0.07,0.51v1.75h-0.95V293.17z"
              />
            </g>
          </g>
        </g>
      </svg>
    );
  }
}

MyPlate.defaultProps = {
  selectedComponents: {
    hasDairy: false,
    hasFruit: false,
    hasGrain: false,
    hasProtein: false,
    hasVegetable: false,
  },
  isSmallSize: false,
};

MyPlate.propTypes = {
  selectedComponents: PropTypes.shape({
    hasDairy: PropTypes.bool,
    hasFruit: PropTypes.bool,
    hasGrain: PropTypes.bool,
    hasProtein: PropTypes.bool,
    hasVegetable: PropTypes.bool,
  }),
  isSmallSize: PropTypes.bool,
};

export { MyPlate };



// WEBPACK FOOTER //
// ./src/common/Components/MyPlate/MyPlate.js